import type { PropsWithChildren } from 'react'
import { Body1, Grid, H5 } from '@dhl-ui/components'

type Props = PropsWithChildren<{
  title: string
  description: string
}>

export const DangerZoneContainer = ({ title, description, children }: Props) => (
  <Grid
    container
    size={{ xs: 6 }}
    sx={{ display: 'flex', p: 3, justifyContent: 'flex-start' }}
    direction="column"
    spacing={2}
  >
    <Grid container sx={{ mt: 1 }}>
      <H5>{title}</H5>
    </Grid>
    <Grid container sx={{ mt: 1 }}>
      <Body1>{description}</Body1>
    </Grid>
    <Grid
      container
      sx={{
        mt: 2,
        flex: 1,
        alignItems: 'flex-end',
      }}
    >
      {children}
    </Grid>
  </Grid>
)
